import actions from "./action";

const setGlobalProfile = (profile) => {
  return async (dispatch) => {
    dispatch(actions.setProfile(profile));
  };
};

export { setGlobalProfile };
